export function accordion() {
  const accordionElements = document.querySelectorAll('.accordion');

  accordionElements.forEach(accordion => {
    const questionElement = accordion.querySelector('.accordion-title');
    const answerElement = accordion.querySelector('.accordion-content');
    let contentHeight = answerElement.scrollHeight + 'px';

    questionElement.addEventListener('click', function () {
      accordion.classList.toggle('active');

      contentHeight = answerElement.scrollHeight + 'px';

      answerElement.style.height = accordion.classList.contains('active') ? contentHeight : '0';
    });
  });
}


// WEBPACK FOOTER //
// app/scripts/components/accordion.js